/**
 * 封面相关纯函数（抽离自 MusicPlayer.js）
 */
import { getCoverStreamUrl } from '../../../utils/musicStreamUrls';

/**
 * 从 music 对象解析封面 URL
 * @param {object|null} music
 * @returns {string|null}
 */
export function getCoverUrlFromMusic(music) {
  if (!music) return null;
  // 封面只请求 webp：不回退 cover_image/cover_url（避免请求 jpg）
  return getCoverStreamUrl(music) || null;
}

/**
 * 根据播放模式获取“下一首”用于封面预加载（sequential 时取下一首，repeat 时取当前首，random 不预加载）
 * @param {Array} playlist
 * @param {object|null} currentMusic
 * @param {string} playMode - 'sequential' | 'random' | 'repeat'
 * @param {boolean} playlistLoop
 * @returns {object|null}
 */
export function getNextMusicForCover(playlist, currentMusic, playMode, playlistLoop) {
  if (!playlist || playlist.length === 0 || !currentMusic) return null;
  const currentIndex = playlist.findIndex((m) => m.id === currentMusic.id);
  if (currentIndex < 0) return null;
  if (playMode === 'repeat') return playlist[currentIndex] || null;
  if (playMode === 'random') return null;
  let nextIndex = currentIndex + 1;
  if (nextIndex >= playlist.length) {
    if (!playlistLoop) return null;
    nextIndex = 0;
  }
  return playlist[nextIndex] || null;
}
